import FileUpload from "./FileUpload";
import HttpRequest from "./HttpRequest";
const httpErrorHandler = (error) => {
  alert(`Error: \n${error ? error : ''}`)
  console.log('httpError: ', error);
}

export { httpErrorHandler, HttpRequest, FileUpload }
